import { API_URLS } from "@/api/urls";
import axiosInstance from "@/inteceptors";

export const updateProfile = async (
  data: ProfileUpdatePayload
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.PROFILE.UPDATE_PROFILE,
    data
  );
  return response.data;
};

export const updateCustomerBookingPolicy = async (
  data: CustomerBookingPolicyPayload
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.PROFILE.CUSTOMER_BOOKING_POLICY_UPDATE,
    data
  );
  return response.data;
};

export const updateProfileLogo = async (
  formData: FormData
): Promise<IResponse> => {
  const response = await axiosInstance.put<IResponse>(
    API_URLS.PROFILE.UPDATE_PROFILE_LOGO,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const createRegionDateSettings = async (
  data: RegionDateSettingPayload
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.LANGUAGE_REGION.CREATE_LANGUAGE_SETTINGS,
    data
  );
  return response.data;
};

export const updateRegionDateSettings = async (
  data: RegionDateSettingPayload & { id?: number }
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.put<ISuccessResponse>(
    `${API_URLS.LANGUAGE_REGION.UPDATE_LANGUAGE_SETTINGS}${
      data.id ? `${data.id}/` : ""
    }`,
    data
  );
  return response.data;
};

export const updateAdministratorBookingPolicy = async (
  data: AdminBookingPolicyPayload
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.PROFILE.ADMIN_BOOKING_POLICY_UPDATE,
    data
  );
  return response.data;
};

export const updateEmployeeBookingPolicy = async (
  data: EmployeeBookingPolicyPayload
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.PROFILE.EMPLOYEE_BOOKING_POLICY_UPDATE,
    data
  );
  return response.data;
};

export const createVenueSettings = async (
  data: VenueSettingsPayload
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.VENUE.CREATE_VENUE_SETTINGS,
    data
  );
  return response.data;
};

export const updateVenueSettings = async (
  data: VenueSettingsPayload & { id?: number }
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.put<ISuccessResponse>(
    `${API_URLS.VENUE.UPDATE_VENUE_SETTINGS}${data.id ? `${data.id}/` : ""}`,
    data
  );
  return response.data;
};

export const addUser = async (
  data: AddUserPayload
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.MANAGE_USERS.ADD_USER,
    data
  );
  return response.data;
};

export const updateUser = async (
  data: Partial<AddUserPayload> & { id?: number }
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.patch<ISuccessResponse>(
    `${API_URLS.MANAGE_USERS.UPDATE_USER}${data.id ? `${data.id}/` : ""}`,
    data
  );
  return response.data;
};

export const deleteUser = async (id: number): Promise<ISuccessResponse> => {
  const response = await axiosInstance.delete<ISuccessResponse>(
    `${API_URLS.MANAGE_USERS.DELETE_USER}${id}/`
  );
  return response.data;
};

export const downgradeUser = async (id: number): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    `${API_URLS.MANAGE_USERS.DOWNGRADE_USER}${id}/downgrade-to-customer/`
  );
  return response.data;
};

export const assignRoles = async ({
  userId,
  data,
}: {
  userId: number;
  data: AssignRolesPayload;
}): Promise<ISuccessResponse> => {
  const response = await axiosInstance.put<ISuccessResponse>(
    `${API_URLS.MANAGE_USERS.ASSIGN_ROLES}${userId}/`,
    data
  );
  return response.data;
};

export const createBay = async (
  data: Omit<Bay, "id" | "status" | "out_of_service" | "reason">
): Promise<ISuccessResponse> => {
  const response = await axiosInstance.post<ISuccessResponse>(
    API_URLS.BOOKINGS.BAYS,
    data
  );
  return response.data;
};

export const updateBay = async (data: Bay): Promise<ISuccessResponse> => {
  const response = await axiosInstance.patch<ISuccessResponse>(
    `${API_URLS.BOOKINGS.BAYS}${data.id}/`,
    data
  );
  return response.data;
};

export const deleteBay = async (id: number): Promise<ISuccessResponse> => {
  const response = await axiosInstance.delete<ISuccessResponse>(
    `${API_URLS.BOOKINGS.BAYS}${id}/`
  );
  return response.data;
};
